export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const API_TOKEN = process.env.REACT_APP_API_TOKEN;

console.log('Current API_URL:', process.env); // Good for debugging
console.log('Current API_TOKEN:', API_TOKEN); // Good for debugging
 